import { render, staticRenderFns } from "./fid_traction.vue?vue&type=template&id=be838a0a&"
import script from "./fid_traction.vue?vue&type=script&lang=js&"
export * from "./fid_traction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports